"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.reportMessage = exports.reportWarning = exports.reportError = void 0;
exports.reportError = function (message) {
    console.error("Wix code SDK error: " + message);
};
exports.reportWarning = function (message) {
    console.warn("Wix code SDK warning: " + message);
};
exports.reportMessage = function (message) {
    console.log("Wix code SDK message: " + message);
};
//# sourceMappingURL=reporters.js.map